import IconButton from '@mui/material/IconButton';
import { ReactComponent as DeleteIcon } from '../assets/icons/main/delete-icon.svg';
import { useTheme } from '@mui/material';

interface DeleteButtonPropTypes {
  onClick: () => void;
  disabled?: boolean;
  isFrom?: boolean;
}

const Styles = {
  icon: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
  },
};

const DeleteButton = ({ onClick, disabled, isFrom }: DeleteButtonPropTypes) => {
  const theme:any = useTheme();
  return (
    <IconButton onClick={onClick} disabled={disabled} sx={{ marginTop: isFrom ? '-20px' : '0px' }}>
      <DeleteIcon style={{ ...Styles.icon, opacity: disabled ? 0.5 : 1, color : theme.palette.custom.light }} />
    </IconButton>
  );
};

export default DeleteButton;
